import { ReactChildren, ReactChild, useState } from 'react'
import { Modal as AntModal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'
import {
  faCheckCircle,
  faCircleInfo,
  faTimesCircle,
} from '@fortawesome/pro-solid-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { ModalWrapper } from './styled'

interface IProps {
  title: string
  close: () => void
  onBack?: () => void
  isOpen?: boolean
  isConfirmation?: boolean
  isInfo?: boolean
  isApproved?: boolean
  maxwidth: number
  maxheight: number
  children: ReactChild | ReactChildren
  actions?: React.ReactNode
  hideFooter?: boolean
  roboto?: boolean
}

export const Modal = ({
  title,
  close,
  onBack,
  isOpen = true,
  isConfirmation = false,
  isInfo = false,
  isApproved,
  maxwidth,
  maxheight,
  children,
  actions,
  hideFooter = false,
  roboto = false,
}: IProps) => {
  const [mountNode, setMountNode] = useState<HTMLDivElement | null>(null)

  return (
    <ModalWrapper
      ref={setMountNode}
      className="rankmi-modal-host"
      isconfirmation={String(isConfirmation)}
      isInfo={String(isInfo)}
      isApproved={String(isApproved)}
      maxwidth={maxwidth}
      maxheight={maxheight}
      $roboto={roboto}
    >
      {mountNode ? (
        <AntModal
          style={{ maxWidth: maxwidth }}
          title={
            <span className="rankmi-modal-title-row">
              {onBack && (
                <button
                  type="button"
                  className="rankmi-modal-back-button"
                  onClick={onBack}
                  aria-label="back"
                >
                  <FontAwesomeIcon icon={faArrowLeft as IconProp} />
                </button>
              )}
              <span>
                {isConfirmation && (
                  <FontAwesomeIcon
                    icon={faExclamationTriangle as IconProp}
                    color="#faad14"
                  />
                )}
                {isInfo && (
                  <FontAwesomeIcon
                    icon={faCircleInfo as IconProp}
                    color="#0085FF"
                  />
                )}
                {isApproved !== undefined && (
                  <FontAwesomeIcon
                    icon={
                      (isApproved ? faCheckCircle : faTimesCircle) as IconProp
                    }
                    color={isApproved ? '#36B37E' : '#CF1322'}
                  />
                )}
                {title}
              </span>
            </span>
          }
          visible={isOpen}
          footer={hideFooter ? null : actions ? actions : <></>}
          onCancel={close}
          closeIcon={<FontAwesomeIcon icon={faTimes as IconProp} />}
          getContainer={() => mountNode}
          centered
        >
          {children}
        </AntModal>
      ) : null}
    </ModalWrapper>
  )
}
